// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReceiverNameAPIModel
 */
export interface GetReceiverNameAPIModel {
    /**
     * 
     * @type {string}
     * @memberof GetReceiverNameAPIModel
     */
    messageId: string;
}

export function GetReceiverNameAPIModelFromJSON(json: any): GetReceiverNameAPIModel {
    return GetReceiverNameAPIModelFromJSONTyped(json, false);
}

export function GetReceiverNameAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReceiverNameAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'messageId': json['messageId'],
    };
}

export function GetReceiverNameAPIModelToJSON(value?: GetReceiverNameAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'messageId': value.messageId,
    };
}


